// Angular Imports
// =========================================================
import { Component, ViewChild } from '@angular/core'
// AG Grid Imports
// =========================================================
import { type ICellRendererAngularComp } from 'ag-grid-angular'
import { AgCheckboxSelector, PopupComponent, RefPlaceholder } from 'ag-grid-community'
// Custom Imports
// =========================================================
import { ConfirmPopupComponent } from 'src/app/03_shared-components/01_alerts/confirm-popup/confirm-popup.component'
import { IsKeyInObj } from 'src/app/utils/global_functions'

@Component({
  selector: 'checkbox-selection-header-renderer',
  templateUrl: './checkbox-selection-header-renderer.component.html',
  styleUrls: ['./checkbox-selection-header-renderer.component.scss']
})
export class CheckboxSelectionHeaderRenderer extends PopupComponent {
  eCheckbox: any
  params: any

  constructor () {
    super(
            /* html */
            `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`,
            [AgCheckboxSelector]
    )
    this.eCheckbox = RefPlaceholder
  }

  init (params) {
    this.params = params
    const isSelected = this.params.context.getHeaderCheckboxValue()
    const eCheckbox = this.eCheckbox
    eCheckbox.setValue(isSelected)
    const inputEl = eCheckbox.getInputElement()
    inputEl.setAttribute('tabindex', '-1')
    this.setAriaLabel(isSelected)
    this.addManagedListeners(eCheckbox, {
      fieldValueChanged: event => {
        this.setAriaLabel(event.selected)
        if (this.params.context.changeHeaderCheckboxValue) {
          this.params.context.changeHeaderCheckboxValue(event.selected)
        }
      }
    })
  }

  getValue () {
    return this.eCheckbox.getValue()
  }

  focusIn () {
    this.eCheckbox.getFocusableElement().focus()
  }

  afterGuiAttached () {
    if (this.params.cellStartedEdit) {
      this.focusIn()
    }
  }

  isPopup () {
    return false
  }

  setAriaLabel (isSelected) {
    const translate = this.getLocaleTextFunc()
    const stateName = this._getAriaCheckboxStateName(translate, isSelected)
    const ariaLabel = translate('ariaToggleCellValue', 'Press SPACE to toggle cell value')
    this.eCheckbox.setInputAriaLabel(`${ariaLabel} (${stateName})`)
  }

  _getAriaCheckboxStateName (translate, state) {
    console.log('translating state for aria label', state)
    return state === true
      ? translate('ariaChecked', 'checked')
      : state === false
        ? translate('ariaUnchecked', 'unchecked')
        : translate('ariaIndeterminate', 'indeterminate')
  }
}
